import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OrderDesignationSlice, OrderDesignationSliceValue } from './order-designation-types'
import { DEFAULT_DESIGNATION_ID, DEFAULT_DESIGNATION_NAME } from './order-designation-utils'

const INITIAL_STATE: OrderDesignationSlice = {
  value: {
    designationId: DEFAULT_DESIGNATION_ID,
    designationName: DEFAULT_DESIGNATION_NAME,
  },
}

const orderDesignationSlice = createSlice({
  name: 'designation',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<OrderDesignationSliceValue>) => {
      return { ...state, value: action.payload }
    },
  },
})

export default orderDesignationSlice
